import { PersonIcon, PlusIcon } from "@radix-ui/react-icons";
import { useSelector } from "react-redux";
import AddFriendDrawer from "src/components/AddFriendDrawer";
import UserCard from "src/components/UserCard";
import { Button } from "src/components/ui/button";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/components/ui/tabs";
import useSWR from "swr";
import FriendRequests from "../components/FriendRequests";
import Loading from "src/components/Loading";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

export default function Friends() {
  const user = useSelector((state: any) => state.user);

  const { data, error, isLoading } = useSWR<
    {
      userId: string;
    }[]
  >(`${process.env.REACT_APP_API_URL}/users/friends`, fetcher(user.token), {
    refreshInterval: 10000,
  });

  const { data: requestsData } = useSWR<{ userId: string }[]>(
    `${process.env.REACT_APP_API_URL}/users/friend/requests`,
    fetcher(user.token)
  );

  return (
    <>
      <div className="flex justify-between px-4 items-center">
        <h2 className="text-lg font-bold">Přátelé</h2>
        <AddFriendDrawer>
          <Button size="icon">
            <PersonIcon />
            <PlusIcon />
          </Button>
        </AddFriendDrawer>
      </div>

      <Tabs defaultValue="friends" className="p-4">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="friends">Přatelé ({data?.length})</TabsTrigger>
          <TabsTrigger value="friendRequests">
            Žádosti ({requestsData?.length})
          </TabsTrigger>
        </TabsList>
        <TabsContent value="friends" className="pt-2">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {isLoading && <Loading />}
            {error && !isLoading && (
              <div style={{ textAlign: "center" }}>
                Někde se stala chyba, zkus to prosím později.
              </div>
            )}
            {data &&
              data.map((user) => (
                <UserCard key={user.userId} userId={user.userId} />
              ))}
          </div>
        </TabsContent>
        <TabsContent value="friendRequests" className="pt-2">
          <FriendRequests />
        </TabsContent>
      </Tabs>
    </>
  );
}
